"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVinDate = void 0;
var getVinDate = function () {
    var date = new Date();
    var months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря',
    ];
    var day = date.getDate();
    var month = months[date.getMonth()];
    return "\u041E\u0442 ".concat(day, " ").concat(month, " ").concat(date.getFullYear(), " \u0433\u043E\u0434\u0430");
};
exports.getVinDate = getVinDate;
